<template>
  <banner-detail :is-edit='true' :groupId="this.$route.params.groupId">
  </banner-detail>
</template>

<script>
import BannerDetail from '@/components/Shop/Theme/BannerDetail'
export default {
  name: 'EditBanner',
  components: {
    BannerDetail
  },
  created() {
    console.log(this.$route.params.bannerId)
    // console.log(this.$route.params.groupId)
  }
}
</script>

